import React from 'react';
import Select from 'react-select';

type CompanySelectProps = {
  companyOfficeOptions: Array<{ value: string; label: string }>;
  height?: number;
  maxWidth?: number;
  placeholder?: string;
  onChange: (option: { value: string }) => void;
};

const CompanyOfficeSelect = ({
  companyOfficeOptions, height = 42, maxWidth = 350, placeholder, onChange
}: CompanySelectProps) => {
  return (
    <Select
      options={companyOfficeOptions}
      placeholder={placeholder}
      styles={{
        control: base => ({
          ...base,
          height,
          maxWidth
        }),
        valueContainer: base => ({
          ...base,
          height,
          paddingBottom: 8,
        }),
        input: base => ({
          ...base,
          height,
          margin: 0,
        }),
        indicatorsContainer: base => ({
          ...base,
          height,
        }),
        placeholder: base => ({
          ...base,
          paddingBottom: 6,
        }),
      }}
      value={null}
      onChange={onChange}
    />
  );
};

export default CompanyOfficeSelect;
